import { useGetParticipantsQuery } from "../participantsSlice";
import useOrganisationId from "../../organisations/hooks/useOrganisationId";
import useHasAccess from "../../../hooks/useHasAccess";

const useParticipant = ({ id }) => {
  const organisationId = useOrganisationId();
  const hasAccess = useHasAccess({
    apiCall: "organisations.id.participants.GET",
    organisation: organisationId,
  });

  const participants = useGetParticipantsQuery(
    { id: organisationId },
    { skip: organisationId == null || !hasAccess }
  );

  const participantData = participants?.data?.find(
    (participant) => participant.id === id
  );

  return { ...participants, data: participantData, hasAccess };
};

export default useParticipant;
